import Layout from '@layout/Index'

export const customerBatch = [
  {
    path: '/customer-batch',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table/:projectid',
      },
      {
        path: 'table/:projectid',
        component: () => import(/* webpackChunkName: "CustomerBatchTable" */ './pages/CustomerBatchTable.vue'),
        name: '客户批次管理',
        meta: {
          title: '客户批次管理',
        },
      },
      {
        path: 'create/project-:projectId',
        component: () => import(/* webpackChunkName: "CustomerBatchForm" */ './pages/CustomerBatchForm.vue'),
        name: '添加客户批次',
        meta: {
          title: '添加客户批次',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "CustomerBatchForm" */ './pages/CustomerBatchForm.vue'),
        name: '修改客户批次',
        meta: {
          title: '修改客户批次',
        },
      },
      {
        path: 'salary-increasing/:batchId',
        component: () => import(/* webpackChunkName: "CustomerBatchTable" */ './pages/SalaryIncreasingTable.vue'),
        name: '客户批次任务加值',
        meta: {
          title: '客户批次任务加值',
        },
      }
    ],
  },
  {
    path: '/batch',
    component: Layout,
    children: [
      {
        path: 'table/:projectid',
        component: () => import(/* webpackChunkName: "CustomerBatchTable" */ './pages/BatchTable.vue'),
        name: '批次管理',
        meta: {
          title: '批次管理',
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/customer-batch/customer-batch.route.js